<section class="parker-banner">
    <app-mini-env-banner [slides]="bannerSlides" [subDescription]="'Clear pricing. Real control.'" (butonAction)="onSliderBtnAction($event)"></app-mini-env-banner>
</section>  

<section class="container-fluid discount-section">
  <div class="container">

    <app-mini-env-heading-block
        [miniTitle]="'Rapid relief for dry mouth'"
        [title]="'Clinically proven benefits for lasting relief'"
        [description]="'Instantly hydration and protection. Aquoral Spray relieves dryness immediately and locks in moisture for all-day comfort.'"
        [style]="'max-width: 703px;'"
        ></app-mini-env-heading-block>

      <div class="row" style="row-gap: 15px;margin-top: 30px;">
        <div *ngFor="let item of clinicalBenefits" class="col-md-4 col-12">
          <app-mini-env-tall-info-card 
                                  [title]="item.title"
                                  [description]="item.description"
                                  [bgImage]="item.bgImage"
                                 >
          </app-mini-env-tall-info-card>
        </div>
      </div>
  </div>
</section>

<section class="container-fluid empower-health-section">
    <div class="container d-flex align-items-center wrapper">
      <div class="col-md-7 col-12">
          <div class="d-flex">
              <div>
                  <app-mini-env-heading-block
                      [miniTitle]="'Symptoms'"
                      [title]="'Signs & Symptoms of Dry Mouth'"
                      [description]="'If you feel a constant dryness or stickiness, or find it uncomfortable to eat or talk, you may be experiencing dry mouth.'"
                      [style]="'max-width: 684px;'" [leftAlign]="true"
                      ></app-mini-env-heading-block>

                    <ul class="d-flex content-list">
                        <li class="bullet-point" *ngFor="let symptom of symptomsList">
                          <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
                          {{ symptom }}
                        </li>
                    </ul>

                    <button (click)="scrollToPlans();" class="btn btn-primary learn-more mt-20">
                      Get Started
                    </button>
              </div>
          </div>
      </div>
      <div class="col-md-5 col-12">
          <div class="d-flex justify-content-center img-box">
            <img [src]="'assets/tenant-assets/mini-env/aquoral/aquoral-ice.jpg'" style="object-fit: cover;border-radius: 8px;" alt="">
          </div>
      </div>
  </div>
</section>

<section class="container-fluid factors-section">
  <app-mini-env-heading-block
  [miniTitle]="'Causes of Dry Mouth'"
  [title]="'Unveiling the Underlying Factors'"
  [description]="'Understand the main causes of dry mouth and take proactive steps. Find relief with simple changes to your daily routine.'"
  [style]="'max-width: 703px;'"
  ></app-mini-env-heading-block>
  <app-mini-env-img-card-slide></app-mini-env-img-card-slide>
</section>

<section class="container-fluid spray-usage-section">
  <div class="container">

    <app-mini-env-heading-block
        [miniTitle]="'Spray Usage'"
        [title]="'Why use a spray for Dry Mouth'"
        [description]="'Get instant, portable relief with a convenient solution that works whenever and wherever you need it.'"
        [style]="'max-width: 703px;'"
        ></app-mini-env-heading-block>

      <div class="row" style="margin-top: 30px;">
        <div *ngFor="let item of sprayBenefits" class="col-md-4 col-6 p-2">
          <div class="card-box">
              <div class="d-flex justify-content-between img-row">
                  <div>
                      <img width="42" [src]="sharedService.imagesUrl + item.icon" alt="">
                  </div>
                  <div>
                      <!-- <img *ngIf="isFree" width="53" [src]="icon2" alt=""> -->
                  </div>
              </div>
              <div>
                  <h3 class="benefit-title">{{ item.title }}</h3>
                  <p class="benefit-desc">{{ item.description }}</p>
              </div>
          </div>
        </div>
      </div>
  </div>
</section>

<section id="membership-section" class="container-fluid membershipplans-section membership-section">
  <div class="container">
    <div class="row basic-section-gap" style="flex-direction: row;">
      <div class="col-md-12">
        <app-mini-env-heading-block
            [miniTitle]="'Affordable Healthcare solution for you!'"
            [title]="'Healthcare access with membership,no insurance needed'"
            [style]="'max-width: 684px;'"
            ></app-mini-env-heading-block>
      </div>
      <div class="col-md-12">
        <app-membership-plan *ngIf="membershipPlanCode"
            [label]="('MEMBERSHIP.LABEL' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note1]="('MEMBERSHIP.NOTE1' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note2]="('MEMBERSHIP.NOTE2' | translateIt: {language: sharedService.currentLanguage} | async)"
            [note3]="('MEMBERSHIP.NOTE3' | translateIt: {language: sharedService.currentLanguage} | async)"
            [membershipPlanCode]="membershipPlanCode"
            [btnLabel]="'Select Membership'"></app-membership-plan>
      </div>

    </div>
  </div>
</section>

<section class="container-fluid bg-content">
  <div class="container">
    <app-mini-env-bg-content [title]="'Your health simplified with WoW Health'" 
                             [description]="'Experience seamless healthcare with WoW Health. Sign up today and receive care anytime, anywhere! Seize this amazing deal now. Limited time only.'"
                             [bgClass]="bgClass" (buttonAction)="scrollToPlans();"></app-mini-env-bg-content>
  </div>
</section>

<!-- <section class="container-fluid">
    <div class="container">
        <div class="tabs">

            <div class="tab-headers">
                <button
                *ngFor="let pane of panes; let i = index"
                (click)="select(i)"
                [class.active]="pane.active"
                class="tab-btn"
                >
                {{ pane.title }}
                </button>
            </div>

            <div class="tab-body">
                <div *ngFor="let pane of panes; let i = index">
                    <app-mini-env-content-box *ngIf="pane.active" [imgSrc]="imgSrc">
                        <h2 class="content-heading">{{ pane.title }}</h2>
                        <p class="content-txt">
                        Licensed Medics to guide with care decisions, with FREE virtual care.
                        </p>

                        <ul class="d-flex content-list">
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""> Appointment with the same doctor - no long waiting hours.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""> 24/7 access to virtual care for non-emergency issues.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">/7 Mental health and personal life support with specialists.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""> Quick response on medical concerns via secure chat.</li>
                        </ul>

                        <button class="btn btn-primary">Get Started</button>
                    </app-mini-env-content-box>
                </div>
            </div>

        </div>
    </div>
</section> -->

<section class="container-fluid faq-section">
  <div class="container">
    
    <app-mini-env-heading-block
    [miniTitle]="'FAQs'"
    [title]="'Frequently Asked Questions'"
    [description]="'Some questions you might have in your mind. If you couldnt find yours, call us anytime at 844-969-4325'"
    [style]="'max-width: 684px;'"
    ></app-mini-env-heading-block>

    <div class="mt-30">
       <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>  

<section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section>
<!--  How can we help Section End-->
